module.exports = __webpack_public_path__ + "img/order-tab-delivered.11577802.png";